import React from 'react';
import { motion } from 'framer-motion';
import Topnav from '@/components/topnav';
import styles from './promote.module.css';

const pageVariants = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.4 } },
  exit: { opacity: 0, y: -10, transition: { duration: 0.3 } },
};

const IframePromote = () => {
  return (
    <section className={styles.Home}>
        <Topnav />
          <div className={styles.main}>
           
          <motion.div variants={pageVariants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
          className={styles.container}>
          <iframe
            src="frames/promote/index.html" /* https://mixtaperadio.web.app/     https://mixtaperadio.web.app/frames/promote/index.html      http://192.168.1.122:5176/ */
            className={styles.iframe}
            title="Promote"
          />
        </motion.div>
          </div>
    </section>
  );
};

export default IframePromote;